import { useCallback } from 'react';

const useFirstFocusable = () => {
  return useCallback(
    (container: HTMLElement | null | undefined): HTMLElement | null => {
      if (!container) return null;

      const focusable = container.querySelector<HTMLElement>(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), [contenteditable="true"]'
      );

      return focusable ?? null;
    },
    []
  );
};

export default useFirstFocusable;
